import { Image } from '@ds';
import styles from '../../CaseCard.module.scss';

type TimeLineItemProps = {
  color: string;
  image: string;
  label: string;
  value?: string;
  withLineLeft?: boolean;
  withLineRight?: boolean;
};

export const TimeLineItem = ({ color, image, label, value, withLineLeft, withLineRight }: TimeLineItemProps) => (
  <div className={`flex flex-col items-center gap-2 ${value ? '' : 'opacity-60'}`}>
    <div className={`p-2 w-10 rounded-full relative ${value ? color : 'bg-base-40'}`}>
      {withLineLeft && <div className={`${styles.timeLineDash} -left-3`} />}
      <Image src={image} />
      {withLineRight && <div className={`${styles.timeLineDash} -right-3`} />}
    </div>
    <div className="text-xs-m text-center">
      <div className="text-base-20 mb-1">{label}</div>
      <div>{value || '--:--'}</div>
    </div>
  </div>
);
